import { render, staticRenderFns } from "./Operario.vue?vue&type=template&id=bf2d8ac4&"
import script from "./Operario.vue?vue&type=script&lang=js&"
export * from "./Operario.vue?vue&type=script&lang=js&"
import style0 from "./Operario.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports